import React, { Component } from "react";
import styles from "../customerInfo/CustomerInfo.module.scss";
import sharedStyles from "../OrderDetailsNewVersion.module.scss";
import Grid from "@material-ui/core/Grid";
import { withTranslation } from "react-i18next";
import crStyles from "../../../customerReservation/crStyles";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import UpperCaseText from "../../../../utils/UpperCaseText";
import {
  StyledBasicExpansionPanel,
  StyledBasicExpansionPanelSummary,
} from "../../../../shared/ExpansionPanels/ExpansionPanel";
import {
  IS_ITALY_MARKET,
  NOTNULL_OR_NOTUNDEFINED,
  statusMap,
} from "../../../../utils/EmpUtil";
import UiDateUtils from "../../../../utils/UiDateUtils";
import {
  AL,
  BEV_VEHICLES,
  CANCELLED,
  E_COMMERCE_ISSUE_REPORT_FORM_URL,
  VEHICLE_RESERVATION_FLOW_DIAGRAM_URL,
} from "../../../../common/Constants";
import SpecsDialog from "./SpecsDialog";
import CapitalizeText from "../../../../utils/CapitalizeText";
import { HANDOVER_STATUS } from "../handOver/Constants";
import HasPermissionTo from "../../../../common/HasPermissionTo";
import SharedToolTip from "../../../../shared/sharedToolTip/SharedToolTip";

const InfoDetail = ({
  header: header,
  value: value,
  status: status,
  openTestid: openTestid,
  closeTestid: closeTestid,
  open: open,
  closeTooltip: closeTooltip,
  openTooltip: openTooltip,
  title: title,
  body: body,
}) => {
  const confirmedStatuses = [
    "created",
    "contracted",
    "confirmed",
    "ordered",
    "completed",
  ];
  return (
    <>
      <div className={styles.itemHeaderTextWithToolTip}>
        {header}
        {body && (
          <SharedToolTip
            openTestid={openTestid}
            closeTestid={closeTestid}
            title={title}
            open={open}
            closeTooltip={closeTooltip}
            openTooltip={openTooltip}
            body={body}
          />
        )}
      </div>
      <div
        className={
          NOTNULL_OR_NOTUNDEFINED(status)
            ? status === "cancelled"
              ? styles.cancelledItemValueText
              : confirmedStatuses.includes(status)
              ? styles.confirmedItemValueText
              : status === "amended"
              ? styles.amendedItemValueText
              : styles.itemValueText
            : styles.itemValueText
        }
      >
        {value || "--"}{" "}
      </div>
    </>
  );
};

class OrderInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expandOrderInfo: true,
      showSpecs: false,
      orderStatusToolTipOpen: false,
    };
  }

  expandOrderInfo() {
    this.setState((prevState) => ({
      expandOrderInfo: !prevState.expandOrderInfo,
    }));
  }

  getDepositPrice() {
    const customerReservation = this.props.customerReservation;
    const pricingStack =
      customerReservation && customerReservation.pricingStack;

    return UpperCaseText(customerReservation.orderType) === "ORDER"
      ? NOTNULL_OR_NOTUNDEFINED(pricingStack.orderDepositPrice) &&
          `${this.props.defaultCurrency}${pricingStack.orderDepositPrice}`
      : NOTNULL_OR_NOTUNDEFINED(pricingStack.reservationDepositPrice) &&
          `${this.props.defaultCurrency}${pricingStack.reservationDepositPrice}`;
  }

  getVehicleEUFeatures = (order) => {
    return order && order.vehicleEUFeatures.Extras
      ? order.vehicleEUFeatures.Extras
      : order.vehicleEUFeatures.J4W || order.vehicleEUFeatures.J5X
      ? order.vehicleEUFeatures.J4W || order.vehicleEUFeatures.J5X
      : "--";
  };

  getOrderCompletionDate = (order) => {
    const received =
      order?.handoverappointmentConfirmedData?.appointmentInfoData?.filter(
        (appointmentInfo) =>
          appointmentInfo.appointmentStatus === HANDOVER_STATUS.RECEIVED
      );

    if (received.length > 0) {
      return UiDateUtils.formatYYYYMMDDToEUWithoutTime(
        received[0].dealerActionDate
      );
    }
    return "";
  };

  getOrderCancellationDate = (order, status) => {
    let cancelledDate = "";
    if (
      (status === "DEALER_CANCELLED" ||
        status === "CONTRACT_CANCEL_REQUESTED") &&
      order.orderDetailsDealerAction &&
      order.orderDetailsDealerAction.dealerAction &&
      UpperCaseText(order.orderDetailsDealerAction.dealerAction) === CANCELLED
    ) {
      cancelledDate = order.orderDetailsDealerAction.dealerActionDate;
    } else if (
      status === "ORDER_CANCELLED" ||
      status === "RESERVATION_CANCELLED"
    ) {
      cancelledDate =
        (order && order.cancellation && order.cancellation.cancellationDate) ||
        (order && order.cancellationDate);
    }

    if (!cancelledDate && order && order.cancellationDate) {
      cancelledDate = order.cancellationDate;
    }

    return cancelledDate ? cancelledDate.replaceAll("-", "/") : "";
  };

  getFormattedOrderStatus = (businessStatus, status) => {
    let formattedStatus = businessStatus;
    if (
      NOTNULL_OR_NOTUNDEFINED(businessStatus) &&
      NOTNULL_OR_NOTUNDEFINED(status) &&
      businessStatus.toUpperCase() !== status.toUpperCase()
    ) {
      formattedStatus += " / " + status.replaceAll("_", " ");
    }
    return formattedStatus;
  };

  toggleSpecs = () => {
    this.setState((prevState) => ({
      showSpecs: !prevState.showSpecs,
    }));
  };

  toggleCustomerInfoToolTip = () => {
    this.setState((prevState) => ({
      orderStatusToolTipOpen: !prevState.orderStatusToolTipOpen,
    }));
  };

  getOrderStatusTooltipBody() {
    return (
      <>
        <div className={styles.confirmedItemToolTip}>
          <li>{this.props.t("OrderInfo.orderStatusTooltipBullet1")}</li>
          <li>{this.props.t("OrderInfo.orderStatusTooltipBullet2")}</li>
          <li>
            {this.props.t("OrderInfo.orderStatusTooltipBullet3")}{" "}
            <a href={E_COMMERCE_ISSUE_REPORT_FORM_URL}>
              {this.props.t("GeneralEMP.here")}
            </a>
          </li>
          <li>{this.props.t("OrderInfo.orderStatusTooltipBullet4")}</li>
        </div>
        <div className={styles.cancelledItemToolTip}>
          <li>{this.props.t("OrderInfo.orderStatusTooltipBullet5")}</li>
          <li>{this.props.t("OrderInfo.orderStatusTooltipBullet7")}</li>
          <li>{this.props.t("OrderInfo.orderStatusTooltipBullet6")}</li>
        </div>
        <div className={styles.itemToolTip}>
          <a href={VEHICLE_RESERVATION_FLOW_DIAGRAM_URL}>
            {this.props.t("OrderInfo.orderStatusTooltipChartTitle")}
          </a>
        </div>
      </>
    );
  }

  render() {
    const order = this.props.customerReservation;
    const isInforDetailFromItaly = IS_ITALY_MARKET(this.props.market);

    return (
      <div>
        <StyledBasicExpansionPanel
          defaultExpanded={true}
          onChange={() => this.expandOrderInfo()}
        >
          <StyledBasicExpansionPanelSummary
            style={crStyles.headerBarNeutral}
            id="exp"
          >
            <div className={sharedStyles.headerBar}>
              <div className={sharedStyles.boldHeader}>
                {this.props.t("OrderInfo.header")}
              </div>
              {this.state.expandOrderInfo ? (
                <ExpandLessIcon id="less" />
              ) : (
                <ExpandMoreIcon id="more" />
              )}
            </div>
            <br />
          </StyledBasicExpansionPanelSummary>
          <div className={styles.customerInfoGrid}>
            <div className={styles.bottomBorder}></div>

            {order ? (
              <Grid container className={styles.customerContainer}>
                <Grid item xs={3}>
                  <div className={styles.infoHeader}>
                    {this.props.t("OrderInfo.orderDetailsSubheader")}
                  </div>
                  <InfoDetail
                    header={this.props.t("OrderInfo.orderNumber")}
                    value={order.id}
                  />
                  <HasPermissionTo
                    perform={["enhancedOrderStatus:view"]}
                    permissions={this.props.user.permissions.rolePermissions}
                    render={() => (
                      <InfoDetail
                        header={this.props.t("OrderInfo.orderStatus")}
                        value={this.getFormattedOrderStatus(
                          order.businessStatus,
                          order.status
                        )}
                        status={statusMap[order.status]}
                        openTestid="orderStatusOpenToolTip"
                        closeTestid="orderStatusCloseToolTip"
                        open={this.state.orderStatusToolTipOpen}
                        closeTooltip={this.toggleCustomerInfoToolTip}
                        openTooltip={this.toggleCustomerInfoToolTip}
                        title={this.props.t(
                          "OrderInfo.orderStatusTooltipTitle"
                        )}
                        body={this.getOrderStatusTooltipBody()}
                      />
                    )}
                    noRender={() => (
                      <InfoDetail
                        header={this.props.t("OrderInfo.orderStatus")}
                        value={order.businessStatus}
                        status={statusMap[order.status]}
                      />
                    )}
                  />

                  <InfoDetail
                    header={this.props.t("OrderDetails.channel")}
                    value={
                      UpperCaseText(order.orderType) === "RESERVATION"
                        ? order.reservationChannel
                        : order.orderChannel
                    }
                  />
                  {!isInforDetailFromItaly && (
                    <InfoDetail
                      header={this.props.t("OrderInfo.preOrderDate")}
                      value={order.date.replaceAll("-", "/")}
                    />
                  )}
                  {statusMap[order.status] === "completed" && (
                    <InfoDetail
                      header={this.props.t("OrderInfo.completionDate")}
                      value={this.getOrderCompletionDate(order)}
                    />
                  )}
                  {statusMap[order.status] === "cancelled" && (
                    <InfoDetail
                      header={this.props.t("OrderInfo.cancellationDate")}
                      value={this.getOrderCancellationDate(order, order.status)}
                    />
                  )}

                  <InfoDetail
                    header={this.props.t("OrderInfo.inventory")}
                    value={
                      order.hasInventory
                        ? this.props.t("GeneralEMP.statusYes")
                        : this.props.t("GeneralEMP.statusNo")
                    }
                  />
                  {order.placedByReserver !== null && (
                    <InfoDetail
                      header={this.props.t("OrderInfo.placedByReserver")}
                      value={
                        order.placedByReserver
                          ? this.props.t("GeneralEMP.statusYes")
                          : this.props.t("GeneralEMP.statusNo")
                      }
                    />
                  )}
                </Grid>
                <Grid item xs={3}>
                  <div className={styles.infoHeader}>&nbsp;</div>
                  <InfoDetail
                    header={this.props.t("OrderInfo.deposit")}
                    value={this.getDepositPrice()}
                  />
                  <InfoDetail
                    header={this.props.t("OrderInfo.vistaDate")}
                    value={order.orbitIdCreatedDate}
                  />
                  <InfoDetail
                    header={this.props.t("OrderInfo.vistaNumber")}
                    value={order.wbdoOrVistaOrderId}
                  />
                  <InfoDetail
                    header={this.props.t("OrderInfo.orbitNumber")}
                    value={order.orbitId}
                  />
                  <InfoDetail
                    header={this.props.t("OrderInfo.paymentType")}
                    value={
                      order.paymentType === AL
                        ? this.props.t("OrderInfo.applyLater")
                        : order.paymentType
                    }
                  />
                </Grid>

                <Grid item xs={3}>
                  <div className={styles.infoHeader}>
                    {this.props.t("OrderInfo.vehicleDetailsSubheader")}
                  </div>
                  <InfoDetail
                    header={this.props.t("OrderInfo.model")}
                    value={order.modelYear + " " + order.nameplate}
                  />
                  <InfoDetail
                    header={this.props.t("OrderInfo.series")}
                    value={
                      order.vehicleEUFeatures &&
                      order.vehicleEUFeatures.MarketedSeries
                    }
                  />
                  <InfoDetail
                    header={
                      BEV_VEHICLES.includes(UpperCaseText(order.nameplate))
                        ? this.props.t("OrderInfo.battery")
                        : this.props.t("OrderInfo.engine")
                    }
                    value={
                      order.vehicleEUFeatures &&
                      order.vehicleEUFeatures.PowerTrain
                    }
                  />
                  <InfoDetail
                    header={this.props.t("OrderInfo.colour")}
                    value={
                      order.vehicleEUFeatures &&
                      order.vehicleEUFeatures.PaintCode
                    }
                  />

                  <div>
                    <div className={styles.itemHeaderText}>
                      {CapitalizeText(
                        this.props.t("CustomerReservations.specs") + ": "
                      )}
                    </div>
                    <button
                      className={styles.linkButton}
                      onClick={this.toggleSpecs}
                    >
                      {this.props.t("CustomerReservations.view")}
                    </button>
                  </div>
                </Grid>

                <Grid item xs={3}>
                  <div className={styles.infoHeader}>&nbsp;</div>
                  <InfoDetail
                    header={this.props.t("OrderInfo.interior")}
                    value={
                      order.vehicleEUFeatures &&
                      order.vehicleEUFeatures.Interior
                    }
                  />
                  <InfoDetail
                    header={this.props.t("OrderInfo.extras")}
                    value={
                      order.vehicleEUFeatures &&
                      this.getVehicleEUFeatures(order)
                    }
                  />
                  <InfoDetail
                    header={this.props.t("OrderInfo.vin")}
                    value={order.vinNumber}
                  />
                  <InfoDetail
                    header={this.props.t("OrderInfo.estDeliveryDate")}
                    value={
                      UiDateUtils.isAValidDate(order.estimatedDateByLeadTime)
                        ? UiDateUtils.formatyyyymmddTOddmmyyyy(
                            order.estimatedDateByLeadTime,
                            "-",
                            "/"
                          )
                        : order.estimatedDateByLeadTime
                    }
                  />
                  <InfoDetail
                    header={this.props.t(
                      "OrderInfo.latestCommunicatedLeadTime"
                    )} //To do later: Prettyifer makes the below variable in function drop to below line. We know it's wrong but can't compile without it. Can we make the prettifyer ignore these lines so we can make it look right?
                    value={
                      UiDateUtils.isAValidDate(
                        order.dynamicEstimatedDateByLeadTime
                      )
                        ? UiDateUtils.formatyyyymmddTOddmmyyyy(
                            order.dynamicEstimatedDateByLeadTime,
                            "-",
                            "/"
                          )
                        : order.dynamicEstimatedDateByLeadTime
                    }
                  />
                </Grid>
              </Grid>
            ) : (
              <span className={styles.labelError}>
                {" "}
                {this.props.t("CustomerOrderDetails.errorLoadingCustomerInfo")}
              </span>
            )}
          </div>
        </StyledBasicExpansionPanel>
        <SpecsDialog
          open={this.state.showSpecs}
          onClose={this.toggleSpecs}
          specs={order.specs}
        />
      </div>
    );
  }
}

export default withTranslation("emp")(OrderInfo);
